module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loaded) ? _c('div', [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-fixed-top navbar-light navbar-crm"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "nav-menu"
    }
  }, [_c('div', {
    staticClass: "navbar-collapse"
  }, [_c('ul', {
    staticClass: "navbar-nav mr-auto"
  }, [(_vm.activeTabs.length > 1 || _vm.activeDropdownTabs.length > 0) ? _vm._l((_vm.activeTabs), function(tab) {
    return _c('li', {
      key: tab.name,
      staticClass: "nav-item",
      class: {
        active: _vm.currentTab === tab
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab
        }
      }
    }, [_c('a', {
      staticClass: "nav-link",
      attrs: {
        "href": "#"
      }
    }, [_vm._v(_vm._s(tab.name))])])
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "mx-auto order-0"
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('NavbarDropdown', {
    attrs: {
      "currentApp": _vm.currentApp,
      "activeDropdownTabs": _vm.activeDropdownTabs
    },
    on: {
      "click": function (t) {
        _vm.currentTab = t
      },
      "logout": function($event) {
        return _vm.logout()
      }
    }
  })], 1)])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "mode": "out-in"
    }
  }, [_c(_vm.currentTab.component, {
    tag: "component",
    staticClass: "my-3",
    class: _vm.currentTab.classes
  })], 1)], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar-crm__title"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/mydr-logo.png"),
      "alt": "logo"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#nav-menu",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-21c452ac!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/Navbar.vue
// module id = 1090
// module chunks = 0